<button type="button" class="btn btn-primary" id="{{modalOpenButtonId}}" [hidden]="true" data-toggle="modal"
    [attr.data-target]="'#' + modalId" data-backdrop="static" data-keyboard="false" data-dismiss="modal">Hidden
    Btn</button>

<div class="modal link-device-to-vehicle" id="{{modalId}}" tabindex="-1" role="dialog" aria-hidden="true"
    data-backdrop="static">
    <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header popup-header">
                <h5 class="modal-title" id="{{modalId}}Title">{{modalHeader}}</h5>
                <button type="button" id="{{modalCloseButtonId}}" (click)="onCancel()" class="close"
                    data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <!-- <div class="modal-body fix-height-20 d-flex justify-content-center"> -->
            <!-- <div class="modal-body fix-height-40"> -->
            <div class="modal-body pt-2">
                <label *ngIf="isShowSearchInput && content != null" class="align-self-center mt-2">{{content}}</label>

                <!-- <div class="pb-2">
                    <button class="btn btn-primary border" (click)="isShowSearchInput = !isShowSearchInput">
                        <span *ngIf="isShowSearchInput">Hide Search</span>
                        <span *ngIf="!isShowSearchInput">Show Search</span>
                    </button>
                </div> -->

                <!-- <form *ngIf="isShowSearchInput" name="searchVehicle" #searchVehicleForm="ngForm" novalidate (ngSubmit)="onSearch(searchVehicleForm)"> -->
                <!-- <form name="searchVehicle" #searchVehicleForm="ngForm" novalidate (ngSubmit)="onSearch(searchVehicleForm)"> -->
                <!-- <div *ngIf="isShowSearchInput"> -->
                <div [ngClass]="isShowSearchInput?'d-block':'d-none'">
                    <form name="searchVehicle" #searchVehicleForm="ngForm" novalidate
                        (ngSubmit)="onSearch(searchVehicleForm)">
                        <div class="mt-4">
                            <div class="form-group">
                                <div class="input-group">
                                    <!-- <input type="text" class="form-control" placeholder="Search"> -->
                                    <input type="text" class="form-control" id="search" name="search"
                                        placeholder="Search" [(ngModel)]="searchInput" #search="ngModel"
                                        (input)="handleInputChange($event.target.value)"
                                        style="background-color: #eeeeee !important;color: #4c4c4c !important;"
                                        required>
                                    <!-- <div class="input-group-append">
                                        <button class="btn btn-outline-secondary" type="submit">
                                            <i class="fa fa-search"></i>
                                        </button>
                                    </div> -->
                                    <div class="input-group-append">
                                        <button class="btn btn-sm-search" type="submit"><i
                                                class="fa fa-search"></i></button>
                                    </div>
                                </div>
                                <small class="text-danger text-center"
                                    *ngIf="search.errors && searchVehicleForm.submitted">
                                    <p class="mb-0" *ngIf="search.errors.required">*Required</p>
                                </small>
                            </div>
                            <div class="mt-4">
                                <!-- <small class="text-danger"> -->
                                <small class="error-text">
                                    {{invalidVinMessage}}
                                </small>
                            </div>
                        </div>
                    </form>
                </div>
                <!-- <div *ngIf="vehicleData"> -->
                <!-- <div *ngIf="!isShowSearchInput"> -->
                <div [ngClass]="!isShowSearchInput?'d-block':'d-none'">
                    <!-- <button class="btn btn-primary border" (click)="isShowSearchInput = true">
                        <span>Back</span>
                    </button>

                    <i class="fas fa-arrow-left maroon pointer font20 mr-auto" title="Back"
                        (click)="isShowSearchInput = true"></i>

                    <span class="pull-right" (click)="isShowSearchInput = true">
                        <u> Back </u>
                    </span> -->

                    <!-- <div class="form-group maroon forgot-password text-right" (click)="isShowSearchInput = true">
                        <u> Back </u>
                    </div> -->

                    <!-- <i class="fas fa-arrow-left maroon pointer font20 mr-auto" (click)="isShowSearchInput=true"></i> -->


                    <form name="addVehicle" #addVehicleForm="ngForm" novalidate (ngSubmit)="onSubmit(addVehicleForm)">
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label for="vin">VIN</label>
                                    <input type="text" class="form-control" id="vin" name="vin" placeholder="vin"
                                        [(ngModel)]="vehicleData.vin" #vin="ngModel" [readonly]="true">
                                </div>
                            </div>
                            
                            <!-- shu: hidden for now -->
                            <!-- <div class="col pl-0">
                                <div class="form-group">
                                    <label for="licensePlate">License Plate</label>
                                    <input type="text" class="form-control" id="licensePlate" name="licensePlate"
                                        placeholder="License Plate" [(ngModel)]="vehicleData.licensePlate"
                                        #vin="ngModel" [readonly]="isLicensePlateReadOnly">
                                </div>
                            </div> -->
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label for="model">Model</label>
                                    <input type="text" class="form-control" id="model" name="model" placeholder="Model"
                                        [(ngModel)]="vehicleData.model" #model="ngModel" [readonly]="true">
                                </div>
                            </div>
                            <div class="col pl-0">
                                <div class="form-group">
                                    <label for="make">Make</label>
                                    <input type="text" class="form-control" id="make" name="make" placeholder="Make"
                                        [(ngModel)]="vehicleData.make" #make="ngModel" [readonly]="true">
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group">
                                    <label for="color"> Color</label>
                                    <input type="text" class="form-control" id="color" name="color" placeholder="Color"
                                        [(ngModel)]="vehicleData.color" #model="ngModel" [readonly]="true">
                                </div>
                            </div>
                            <div class="col pl-0">
                                <div class="form-group">
                                    <label for="year">Year</label>
                                    <input type="text" class="form-control" id="year" name="year" placeholder="Year"
                                        [(ngModel)]="vehicleData.year" #year="ngModel" [readonly]="true">
                                </div>
                            </div>
                        </div>
                        <button [hidden]="true" id="submitFormId" type="submit" class="btn btn-primary btn-80"></button>
                    </form>

                </div>
            </div>
            <div class="modal-footer">
                <!-- <div *ngIf="!isShowSearchInput">
                    <i class="fas fa-arrow-left maroon pointer font20 mr-auto" (click)="isShowSearchInput=true"></i>
                </div> -->
                <i *ngIf="!isShowSearchInput" class="fas fa-arrow-left maroon pointer font20 mr-auto"
                    (click)="isShowSearchInput=true"></i>

                <button type="button" class="btn btn-light btn-80" (click)="onCancel()">CANCEL</button>
                <button type="button" class="btn btn-primary btn-80" (click)="okClicked()"
                    [disabled]="isShowSearchInput">Submit</button>
            </div>
        </div>
    </div>
</div>